import type { AlertService } from './types'
import type { EndpointsRegistry, FetchClient } from '../types'
import { GatewayEndpoints } from '../endpoints/gateway-endpoints'
import type { Alert, AlertRule } from '~/types/alert'
import type { PaginatedResult, PaginationParams } from '~/types/pagination'
import type { SuccessNoContent } from '~/types/common'

// const _mock = {
//   data: [
//     {
//       id: 110,
//       alertMessages: [{ language: 'fr', message: 'Batterie faible sur un de vos actif' }],
//       level: 'warning',
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Low Voltage',
//           operator: '\u003c',
//           state: 'BATTERY_VOLTAGE',
//           value: '12'
//         }
//       ],
//       description: 'Voltage de moins de 12v. detecté',
//       isActive: true,
//       name: 'Batterie faible',
//       notifiers: null
//     },
//     {
//       id: 114,
//       alertMessages: null,
//       level: 'critical',
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Panneau éteint',
//           operator: '=',
//           state: 'POWER_STATE',
//           value: 'OFF'
//         }
//       ],
//       description: 'Panneau éteint',
//       isActive: false,
//       name: 'Panneau éteint',
//       notifiers: null
//     },
//     {
//       id: 108,
//       alertMessages: [{ language: 'fr', message: 'Batterie en sur-capacité' }],
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Batterie en sur-capacité',
//           operator: '\u003e',
//           state: 'BATTERY_LEVEL',
//           value: '14'
//         }
//       ],
//       description: 'Batterie en sur-capacité',
//       isActive: true,
//       name: 'Batterie en sur-capacité',
//       notifiers: null
//     },
//     {
//       id: 111,
//       alertMessages: [{ language: 'fr', message: 'Batterie faible sur un de vos actif' }],
//       level: 'warning',
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Low Voltage',
//           operator: '\u003c',
//           state: 'BATTERY_VOLTAGE',
//           value: '12'
//         }
//       ],
//       description: 'Voltage de moins de 12v. detecté',
//       isActive: true,
//       name: 'Batterie faible',
//       notifiers: null
//     },
//     {
//       id: 11411,
//       alertMessages: null,
//       level: 'critical',
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Panneau éteint',
//           operator: '=',
//           state: 'POWER_STATE',
//           value: 'OFF'
//         }
//       ],
//       description: 'Panneau éteint',
//       isActive: false,
//       name: 'Panneau éteint',
//       notifiers: null
//     },
//     {
//       id: 10118,
//       alertMessages: [{ language: 'fr', message: 'Batterie en sur-capacité' }],
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Batterie en sur-capacité',
//           operator: '\u003e',
//           state: 'BATTERY_LEVEL',
//           value: '14'
//         }
//       ],
//       description: 'Batterie en sur-capacité',
//       isActive: true,
//       name: 'Batterie en sur-capacité',
//       notifiers: null
//     },
//     {
//       id: 111110,
//       alertMessages: [{ language: 'fr', message: 'Batterie faible sur un de vos actif' }],
//       level: 'warning',
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Low Voltage',
//           operator: '\u003c',
//           state: 'BATTERY_VOLTAGE',
//           value: '12'
//         }
//       ],
//       description: 'Voltage de moins de 12v. detecté',
//       isActive: true,
//       name: 'Batterie faible',
//       notifiers: null
//     },
//     {
//       id: 111141,
//       alertMessages: null,
//       level: 'critical',
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Panneau éteint',
//           operator: '=',
//           state: 'POWER_STATE',
//           value: 'OFF'
//         }
//       ],
//       description: 'Panneau éteint',
//       isActive: false,
//       name: 'Panneau éteint',
//       notifiers: null
//     },
//     {
//       id: 10228,
//       alertMessages: [{ language: 'fr', message: 'Batterie en sur-capacité' }],
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Batterie en sur-capacité',
//           operator: '\u003e',
//           state: 'BATTERY_LEVEL',
//           value: '14'
//         }
//       ],
//       description: 'Batterie en sur-capacité',
//       isActive: true,
//       name: 'Batterie en sur-capacité',
//       notifiers: null
//     },
//     {
//       id: 10822,
//       alertMessages: [{ language: 'fr', message: 'Batterie en sur-capacité' }],
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Batterie en sur-capacité',
//           operator: '\u003e',
//           state: 'BATTERY_LEVEL',
//           value: '14'
//         }
//       ],
//       description: 'Batterie en sur-capacité',
//       isActive: true,
//       name: 'Batterie en sur-capacité',
//       notifiers: null
//     },
//     {
//       id: 10823,
//       alertMessages: [{ language: 'fr', message: 'Batterie en sur-capacité' }],
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Batterie en sur-capacité',
//           operator: '\u003e',
//           state: 'BATTERY_LEVEL',
//           value: '14'
//         }
//       ],
//       description: 'Batterie en sur-capacité',
//       isActive: true,
//       name: 'Batterie en sur-capacité',
//       notifiers: null
//     },
//     {
//       id: 10824,
//       alertMessages: [{ language: 'fr', message: 'Batterie en sur-capacité' }],
//       conditions: [
//         {
//           hysteresis: 0,
//           name: 'Batterie en sur-capacité',
//           operator: '\u003e',
//           state: 'BATTERY_LEVEL',
//           value: '14'
//         }
//       ],
//       description: 'Batterie en sur-capacité',
//       isActive: true,
//       name: 'Batterie en sur-capacité',
//       notifiers: null
//     }
//   ],
//   pagination: {
//     per_page: 10,
//     current_page: 1,
//     sort: '',
//     total: 40,
//     total_pages: 4
//   }
// } as PaginatedResult<AlertRule>
const _alertsMock = {
  $schema: 'https://staging.scms-api-gateway.fundamentum-iot.com/schemas/PaginatedResultAlertDto.json',
  data: [
    {
      triggeredConditions: [],
      createdAt: '2025-08-14T17:02:15.350708Z',
      assetId: 1,
      id: 337237,
      ruleId: 108,
      stoppedAt: ''
    },
    {
      triggeredConditions: [],
      createdAt: '2025-08-14T17:02:28.898865Z',
      assetId: 2,
      id: 337238,
      ruleId: 108,
      stoppedAt: ''
    },
    {
      triggeredConditions: [],
      createdAt: '2025-08-14T17:02:38.424672Z',
      assetId: 3,
      id: 337239,
      ruleId: 108,
      stoppedAt: ''
    },
    {
      triggeredConditions: [],
      createdAt: '2025-08-14T17:03:08.365445Z',
      assetId: 4,
      id: 337240,
      ruleId: 108,
      stoppedAt: ''
    }
  ],
  pagination: {
    per_page: 0,
    current_page: 0,
    sort: '',
    total: 4,
    total_pages: 4
  }
}

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): AlertService => {
  return {
    getAllAlertRules: async (pagination: PaginationParams): Promise<PaginatedResult<AlertRule>> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ALERT_RULES_GET_ALL, {
        queryParams: {
          current_page: pagination.current_page,
          per_page: pagination.per_page,
          ...(pagination.sort && { sort: pagination.sort })
        }
      })
      return await client<PaginatedResult<AlertRule>>(url, { method, headers, body })
    },
    getAlertRuleById: async (id: number): Promise<AlertRule> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ALERT_RULES_GET_BY_ID, {
        params: { id }
      })
      return await client<AlertRule>(url, { method, headers, body })
    },
    createAlertRule: async (rule: Omit<AlertRule, 'id'>): Promise<AlertRule> => {
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.ALERT_RULES_CREATE,
        undefined,
        rule
      )
      return await client<AlertRule>(url, { method, headers, body })
    },
    updateAlertRule: async (id: number, rule: Partial<AlertRule>): Promise<AlertRule> => {
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.ALERT_RULES_UPDATE,
        {
          params: { id }
        },
        rule
      )
      return await client<AlertRule>(url, { method, headers, body })
    },
    deleteAlertRule: async (id: number): Promise<SuccessNoContent> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ALERT_RULES_DELETE, {
        params: { id }
      })
      return await client(url, { method, headers, body })
    },
    getAlertsByRuleId: async (ruleId: number, pagination: PaginationParams): Promise<PaginatedResult<Alert>> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ALERTS_GET_BY_RULE_ID, {
        params: {
          id: ruleId
        },
        queryParams: {
          current_page: pagination.current_page,
          per_page: pagination.per_page,
          ...(pagination.sort && { sort: pagination.sort })
        }
      })

      return await client<PaginatedResult<Alert>>(url, { method, headers, body })
    },
    dismissAlertById: async (id: number): Promise<SuccessNoContent> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ALERTS_DISMISS_BY_ID, {
        params: { id }
      })
      return await client<SuccessNoContent>(url, { method, headers, body })
    }
  }
}
